export default __webpack_public_path__ + "static/fonts/CamphorPro-Heavy.9f784b4.woff2";